import { NgModule } from '@angular/core';

import { PasswordValidatorDirective } from './password-validator.directive';

@NgModule({
  exports: [PasswordValidatorDirective],
  declarations: [PasswordValidatorDirective],
})
export class PasswordValidatorModule {}
